// extracted by mini-css-extract-plugin
export default {"chipsBox":"ChipSelector_chipsBox__t6zjE"};